// ============================================================
// FOUND legal/support configuration
// Fill in the values marked "CONFIGURE BEFORE PUBLISHING".
// Leaving an email blank will automatically route users to the
// FOUND Support page instead of showing an invented address.
// ============================================================

export const FOUND_CONFIG = {
  company: "Dream Big Entertainment Ltd",
  product: "FOUND",
  location: "London, United Kingdom",
  siteUrl: "https://www.dreambigentertainment.co.uk",

  // ---- CONFIGURE BEFORE PUBLISHING (leave "" if not ready) ----
  contactEmail: "",       // general/support email, e.g. "support@yourdomain.com"
  privacyEmail: "",       // privacy contact (falls back to contactEmail, then Support page)
  copyrightEmail: "",     // copyright/DMCA agent contact
  postalAddress: "",      // full registered company address
  effectiveDate: "August 2026",  // confirm before publishing
  lastUpdated: "August 2026",     // confirm before publishing

  // Known backend provider actually in use (per requirements)
  serviceProviders: [
    { name: "Supabase", purpose: "Backend infrastructure: authentication, database and file storage." },
  ],
};

export const GREEN = "#21E065";

export const LEGAL_NAV = [
  { label: "Legal & Support", to: "/found/legal" },
  { label: "Privacy", to: "/found/privacy" },
  { label: "Terms", to: "/found/terms" },
  { label: "Community Guidelines", to: "/found/community-guidelines" },
  { label: "Copyright", to: "/found/copyright" },
  { label: "Delete Account", to: "/found/delete-account" },
  { label: "Support", to: "/found/support" },
];

// Returns a mailto href if an email is configured, otherwise the Support page.
export const contactTarget = (kind = "contact") => {
  const c = FOUND_CONFIG;
  const email =
    (kind === "privacy" && c.privacyEmail) ||
    (kind === "copyright" && c.copyrightEmail) ||
    c.contactEmail;
  return email ? { href: `mailto:${email}`, isEmail: true } : { href: "/found/support", isEmail: false };
};
